module.exports = __webpack_public_path__ + "media/images/clearco-7dd1f314f8e30d51358c140773ee4539.png";